import React from 'react';
import img from './img/google-maps-mobile.png';

export const GoogleMapsMobile = () => (
    <img src={img} alt="google maps mobile" style={{margin: '0 auto'}}/>
)
